import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_CONTACT_EMAIL, LEGAL_COPYRIGHT, LEGAL_LINK_LABELS } from '../data/legalTexts';

export default function GlobalFooter({ language = 'fr', withBottomNav = false }) {
  const labels = LEGAL_LINK_LABELS[language] || LEGAL_LINK_LABELS.en;
  const aboutLabel = language === 'fr' ? 'À propos' : 'About';

  return (
    <footer className={`px-4 mt-8 ${withBottomNav ? 'pb-24' : 'pb-8'}`}>
      <div className="max-w-md mx-auto border-t border-[rgba(61,61,61,0.12)] pt-5">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-[color:var(--cb-text-muted)]">
          <Link to="/soutenir#histoire" className="hover:text-[color:var(--cb-text)]" aria-label={`${aboutLabel} - ColoBongo`}>
            {aboutLabel}
          </Link>
          <Link to="/privacy" className="hover:text-[color:var(--cb-text)]" aria-label={`${labels.privacy} - ColoBongo`}>
            {labels.privacy}
          </Link>
          <Link to="/terms" className="hover:text-[color:var(--cb-text)]" aria-label={`${labels.terms} - ColoBongo`}>
            {labels.terms}
          </Link>
          <Link to="/cookies" className="hover:text-[color:var(--cb-text)]" aria-label={`${labels.cookies} - ColoBongo`}>
            {labels.cookies}
          </Link>
          <a href={`mailto:${LEGAL_CONTACT_EMAIL}`} className="hover:text-[color:var(--cb-text)]" aria-label={`Contact ColoBongo ${LEGAL_CONTACT_EMAIL}`}>
            {labels.contact}: {LEGAL_CONTACT_EMAIL}
          </a>
        </div>

        <p className="text-[11px] text-[color:var(--cb-text-muted)] mt-3">{LEGAL_COPYRIGHT[language] || LEGAL_COPYRIGHT.en}</p>
      </div>
    </footer>
  );
}
